import './SamplesManagementModal.css';

import React, { useState } from 'react';
import B2BPopUpForm from '../../b2b-common/B2BPopUpForm';
import QuantitativeSamplesManagement from './quant/QuantitativeSamplesManagement';
import { isIndicatorDimensional } from '../components/helper';
import DimQuantitativeSamplesManagement from './dim-quant/DimQuantitativeSamplesManagement';
import QualitativeSamplesManagement from './qual/QualitativeSamplesManagement';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const SamplesManagementModal = ({ open, areaIndicator, onClose = null, onRefresh = null }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const isDimensional = isIndicatorDimensional(areaIndicator.indicatorDTO);

    return (
        <B2BPopUpForm
            open={open}
            title={<span>{t('Area indicator samples')} [{areaIndicator.areaIndicatorName}]</span>}
            onClose={onClose}
            className={'samples-management-modal b2b-light-01'}
        >
            {areaIndicator.indicatorDTO.indicatorType === 'QUALITATIVE' ? (
                <QualitativeSamplesManagement areaIndicator={areaIndicator} onRefresh={onRefresh} />
            ) : areaIndicator.indicatorDTO.indicatorType === 'QUANTITATIVE' ? (
                <QuantitativeSamplesManagement areaIndicator={areaIndicator} onRefresh={onRefresh} />
            ) : areaIndicator.indicatorDTO.indicatorType === 'QUANTITATIVE_DIMENSIONAL' ? (
                <DimQuantitativeSamplesManagement areaIndicator={areaIndicator} onRefresh={onRefresh} />
            ) : null}
        </B2BPopUpForm>
    );
};

export default SamplesManagementModal;